<template>
  <div class="wrapper" :class="[
      { 'nav-open': $sidebar.showSidebar }
    ]">
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>

      <template slot="links">
        <!-- MeriTo -->
        <sidebar-item
          v-if="selectedDevice.type === 1"
          :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/merito/dashboard' }"
        ></sidebar-item>

        <!-- Eymon -->
        <sidebar-item
          v-if="selectedDevice.type === 12"
          :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/eymon/dashboard' }"
        ></sidebar-item>

        <!-- Sense -->
        <sidebar-item
        v-if="selectedDevice.type === 7"
        :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/sense/dashboard' }"
        ></sidebar-item>

        <!-- Applied precision -->
        <sidebar-item
          v-if="selectedDevice.type === 3"
          :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/applied-precision/dashboard' }"
        ></sidebar-item>

        <!-- Octopus -->
        <sidebar-item
          v-if="selectedDevice.type === 4"
          :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/octopus/dashboard' }"
        ></sidebar-item>

        <!-- MeriToNano -->
        <sidebar-item
          v-if="selectedDevice.type === 6"
          :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/meritonano/dashboard' }"
        ></sidebar-item>

        <!-- Disconnector -->
        <sidebar-item
          v-if="selectedDevice.type === 2"
          :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/disconnector/dashboard' }"
        ></sidebar-item>

        <sidebar-item
          v-if="selectedDevice.type === 2"
          :link="{ id: 1, name: $lang.menu.disconnector_timeline, icon: 'timelapse', path: '/disconnector/timeline' }"
        ></sidebar-item>

        <sidebar-item
          v-if="selectedDevice.type === 2"
          :link="{ id: 1, name: $lang.menu.energy_profile, icon: 'timeline', path: '/disconnector/profile' }"
        ></sidebar-item>

        <sidebar-item
          v-if="selectedDevice.type === 2"
          :link="{ name: $lang.menu.analytics, icon: 'assessment' }"
        >
          <sidebar-item
            :link="{ name: $lang.menu.hourly_active_report, path: '/disconnector/energy/hour' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.daily_active_report, path: '/disconnector/energy/day' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.monthly_active_report, path: '/disconnector/energy/month' }"
          ></sidebar-item>
        </sidebar-item>

        <!-- OutageDetector -->
        <sidebar-item
          v-if="selectedDevice.type === 5"
          :link="{ id: 1, name: $lang.menu.dashboard, icon: 'dashboard', path: '/outage-detector/dashboard' }"
        ></sidebar-item>

        <sidebar-item
          v-if="selectedDevice.type === 5"
          :link="{ name: $lang.menu.profile, icon: 'timeline' }"
        >
          <sidebar-item
            :link="{ name: $lang.menu.voltage, path: '/outage-detector/profile/voltage' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="selectedDevice.type === 5"
          :link="{ name: $lang.menu.realtime, icon: 'update' }"
        >
          <sidebar-item
            :link="{ name: $lang.menu.voltage, path: '/outage-detector/realtime/voltage' }"
          ></sidebar-item>
        </sidebar-item>

        <!-- Applied precision - Meters -->
        <sidebar-item v-if="selectedDevice.type === 3" :link="{ name: 'Meters', icon: 'cable' }">
          <sidebar-item :link="{ name: 'Add meter', path: '/applied-precision/meter/add' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Meters list', path: '/applied-precision/meters' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Test list', path: '/applied-precision/meter/tests' }"></sidebar-item>
        </sidebar-item>

        <!-- Applied precision - Measurement -->
        <sidebar-item
          v-if="selectedDevice.type === 3"
          :link="{ name: 'Measurement', icon: 'leaderboard' }"
        >
          <sidebar-item :link="{ name: 'Vector diagram', path: '/applied-precision/vector' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Harmonics chart', path: '/applied-precision/harmonics' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Waveform chart', path: '/applied-precision/waveform' }"></sidebar-item>
        </sidebar-item>

        <!-- Visualization section -->
        <sidebar-item
          v-if="visualizationSectionAccess(selectedDevice.type) && !selectedDevice.macList"
          :link="{ name: $lang.menu.profile, icon: 'timeline' }"
        >
          <sidebar-item
            :link="{ name: $lang.menu.voltage, path: '/visualization/profile/voltage' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.current, path: '/visualization/profile/current' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.active_power, path: '/visualization/profile/power/active' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.reactive_power, path: '/visualization/profile/power/reactive' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.apparent_power, path: '/visualization/profile/power/apparent' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.energy_import, path: '/visualization/profile/energy/import' }"
          ></sidebar-item>
          <sidebar-item
            v-if="selectedDevice.type !== 3"
            :link="{ name: $lang.menu.energy_export, path: '/visualization/profile/energy/export' }"
          ></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Reactive energy', path: '/visualization/profile/energy/reactive' }"
          ></sidebar-item>
          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Apparent energy', path: '/visualization/profile/energy/apparent' }"
          ></sidebar-item>
          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Frequency', path: '/visualization/profile/frequency' }"
          ></sidebar-item>
          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Power factor', path: '/visualization/profile/power-factor' }"
          ></sidebar-item>
          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Distoration Factor of Voltage', path: '/visualization/profile/distoration-factor/voltage' }"
          ></sidebar-item>
          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Distoration Factor of Current', path: '/visualization/profile/distoration-factor/current' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="visualizationSectionAccess(selectedDevice.type) && !selectedDevice.macList"
          :link="{ name: $lang.menu.analytics, icon: 'assessment' }"
        >
          <sidebar-item
            :link="{ name: $lang.menu.quarter_hour_maximum_active_report, path: '/visualization/power/15min/maximum' }"
          ></sidebar-item>

          <!-- 15 MIN maximum from active energy
          <sidebar-item
            :link="{ name: $lang.menu.quarter_hour_maximum_active_report, path: '/visualization/energy/active/15min/maximum' }"
          ></sidebar-item> -->
          <sidebar-item
            :link="{ name: $lang.menu.quarter_hour_active_report, path: '/visualization/energy/active/15min' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.hourly_active_report, path: '/visualization/energy/active/hour' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.daily_active_report, path: '/visualization/energy/active/day' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.monthly_active_report, path: '/visualization/energy/active/month' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.daily_reactive_report, path: '/visualization/energy/reactive/day' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="selectedDevice.type === 1 && selectedDevice.NILM && !selectedDevice.macList"
          :link="{ name: $lang.menu.disaggregation, icon: 'donut_small' }"
        >
          <sidebar-item
            v-if="getAuth.user === 'peter.fecilak@cnl.sk'"
            :link="{ name: 'Recognition DEMO', icon: 'dashboard', path: '/merito/dashboard/recognition' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.appliances_energy, path: '/merito/nilm/appliances/energy' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.appliances_timeline, path: '/merito/nilm/appliances/timeline' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.appliances_run_profile, path: '/merito/nilm/appliances/run-profile' }"
          ></sidebar-item>
          <!--           <sidebar-item
            :link="{ name: $lang.menu.appliances_imprints, path: '/merito/nilm/appliances/imprints' }"
          ></sidebar-item>-->
          <!-- <sidebar-item :link="{ name: $lang.menu.imprints_map, path: '/merito/nilm/imprints-map' }">
          </sidebar-item>-->
          <!-- <sidebar-item
            :link="{ name: $lang.menu.manual_learning, path: '/merito/nilm/appliances/recording' }"
          ></sidebar-item>-->
          <sidebar-item
            :link="{ name: $lang.menu.rising_shapes, path: '/merito/nilm/appliances/shapes/rising' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.falling_shapes, path: '/merito/nilm/appliances/shapes/falling' }"
          ></sidebar-item>
          <sidebar-item :link="{ name: $lang.menu.anomaly_models, path: '/merito/nilm/anomaly' }"></sidebar-item>
          <sidebar-item
            v-if="selectedDevice.owner"
            :link="{ name: $lang.menu.settings, path: '/merito/nilm/settings' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="visualizationSectionAccess(selectedDevice.type) && !selectedDevice.macList"
          :link="{ name: $lang.menu.realtime, icon: 'update' }"
        >
          <sidebar-item
            :link="{ name: $lang.menu.voltage, path: '/visualization/realtime/voltage' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.current, path: '/visualization/realtime/current' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.active_power, path: '/visualization/realtime/power/active' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.reactive_power, path: '/visualization/realtime/power/reactive' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.apparent_power, path: '/visualization/realtime/power/apparent' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $lang.menu.energy_import, path: '/visualization/realtime/energy/import' }"
          ></sidebar-item>
          <sidebar-item
            v-if="selectedDevice.type !== 3"
            :link="{ name: $lang.menu.energy_export, path: '/visualization/realtime/energy/export' }"
          ></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Reactive energy', path: '/visualization/realtime/energy/reactive' }"
          ></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Apparent energy', path: '/visualization/realtime/energy/apparent' }"
          ></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Frequency', path: '/visualization/realtime/frequency' }"
          ></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Power factor', path: '/visualization/realtime/power-factor' }"
          ></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Distoration Factor of Voltage', path: '/visualization/realtime/distoration-factor/voltage' }"
          ></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.type === 3"
            :link="{ name: 'Distoration Factor of Current', path: '/visualization/realtime/distoration-factor/current' }"
          ></sidebar-item>
        </sidebar-item>

        <!-- Tools section -->
        <sidebar-item 
         v-if="!selectedDevice.macList"
        :link="{ name: $lang.menu.tools, icon: 'build' }">
          <sidebar-item :link="{ name: $lang.menu.monitoring, path: '/tools/monitoring' }"></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.owner && getSections.integration"
            :link="{ name: $lang.menu.integration, path: '/tools/integration' }"
          ></sidebar-item>

          <sidebar-item :link="{ name: $lang.menu.notifications, path: '/tools/notifications' }"></sidebar-item>

          <sidebar-item
            v-if="selectedDevice.owner"
            :link="{ name: $lang.menu.firmware_upgrade, path: '/tools/upgrade' }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>

    <Loader v-show="getLoading"></Loader>

    <div class="main-panel" v-show="!getLoading">
      <top-navbar></top-navbar>

      <!-- <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>-->

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import Loader from "@/components/Loader";

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "@/pages/Layout/ContentFooter.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import UserMenu from "@/pages/Layout/UserMenu.vue";
//import FixedPlugin from "@/pages/FixedPlugin.vue";

import { ZoomCenterTransition } from "vue2-transitions";
import { addSeconds, format } from "date-fns";
import { handleRedirect } from "@/routes/routes";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    //FixedPlugin,
    UserMenu,
    ZoomCenterTransition,
    Loader
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true
    };
  },

  computed: {
    notifications() {
      return this.$store.getters.getNotificationList;
    },
    getAuth() {
      return this.$store.getters.getAuth;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    getLoading() {
      return this.$store.getters.getLoading;
    },
    getSections() {
      return this.$store.getters.getAuth.sections ? this.$store.getters.getAuth.sections : {};
    }
  },

  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.type !== oldDevice.type) {
        const route_split = this.$router.currentRoute.fullPath.split("/");
        if (route_split[1] !== "tools") {
          this.$router.push({
            path: handleRedirect()
          });
        }
      }
    },
    notifications: function() {
      const notificationJSON = this.notifications[0];

      //STATUS
      if (notificationJSON.type === "STATUS") {
        let notifyString =
          "<b>" +
          this.$lang.titles.notify_device_status +
          "</b><br>" +
          this.$lang.messages.device_status_change +
          " " +
          notificationJSON.data.event;

        this.showNotification(notifyString);
      }

      //NILM
      else if (notificationJSON.type === "NILM") {
        let notifyString = "<b>NILM</b><br>";
        if (notificationJSON.data.event === "ON") {
          notifyString +=
            this.$lang.general.appliance_on +
            "<br>" +
            notificationJSON.data.name +
            "<br>" +
            this.$lang.charts.phase +
            " " +
            notificationJSON.data.phase;
          // "<br>" +
          // this.$lang.general.identification_success +
          // " " +
          // Number(notificationJSON.data.prediction_rate).toFixed(1) +
          // " %";
        } else if (notificationJSON.data.event === "OFF") {
          const helperDate = addSeconds(
            new Date(0),
            notificationJSON.data.runtime
          );
          const durationString = format(
            helperDate,
            "m [" +
              this.$lang.general.minutes +
              "] [" +
              this.$lang.general.and +
              "] s [" +
              this.$lang.general.seconds +
              "]"
          );

          notifyString +=
            this.$lang.general.appliance_off +
            "<br>" +
            notificationJSON.data.name +
            "<br>" +
            this.$lang.charts.phase +
            " " +
            notificationJSON.data.phase +
            "<br>" +
            this.$lang.general.duration +
            " " +
            durationString +
            "<br>" +
            this.$lang.general.energy_consumption +
            " " +
            Number(notificationJSON.data.energy_consumption_wh).toFixed(1) +
            " Wh";
          // "<br>" +
          // this.$lang.general.identification_success +
          // " " +
          // Number(notificationJSON.data.prediction_rate).toFixed(1) +
          // " %";
        }
        this.showNotification(notifyString);
      }

      //ANOMALY
      else if (notificationJSON.type === "ANOMALY") {
        let notifyString =
          "<b>" +
          this.$lang.titles.notify_anomaly +
          "</b>" +
          "<br>" +
          this.$lang.general.detected_on +
          " " +
          notificationJSON.data.name +
          "<br>";

        switch (notificationJSON.data.type) {
          case 0:
            notifyString += this.$lang.messages.notify_anomaly_S_T;
            break;
          case 1:
            notifyString += this.$lang.messages.notify_anomaly_S_D;
            break;
          case 2:
            notifyString += this.$lang.messages.notify_anomaly_L_D;
            break;
          case 3:
            notifyString += this.$lang.messages.notify_anomaly_L_W;
            break;
          case 4:
            notifyString += this.$lang.messages.notify_anomaly_L_M;
            break;
          case 5:
            notifyString += this.$lang.messages.notify_anomaly_L_Y;
            break;
        }

        notifyString += "<br>";

        notifyString +=
          this.$lang.charts.phase + " " + notificationJSON.data.phase + "<br>";

        this.showNotification(notifyString);
      }

      //DISCONNECTOR
      else if (notificationJSON.type === "DISCONNECTOR") {
        const notifyString =
          "<b>Disconnector</b>" +
          "<br>" +
          (notificationJSON.data.event === "ON"
            ? this.$lang.messages.turn_on_relay
            : this.$lang.messages.turn_off_relay) +
          " " +
          notificationJSON.data.name;

        this.showNotification(notifyString);
      }
    }
  },

  methods: {
    visualizationSectionAccess(deviceType) {
      switch (deviceType) {
        case 1:
        case 3:
        case 4:
        case 6:
      //  case 7:
        case 12:
          return true;
        default:
          return false;
      }
     // return false;
    },

    showNotification: function(msg) {
      this.$notify({
        message: msg,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "info"
      });
    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.main-panel > .content {
  padding: 8px 15px;
}

.charts {
  min-height: 500px;
  height: 70vh;
  width: 100%;
}
</style>
